import React, { useState } from "react";
import ManualNav from "./ManualNav";
import ManualContent from "./ManualContent";
import {
  DEFAULT_LANGUAGE,
  filterManualPages,
  getManualPages,
} from "./manualIndex";

// - - - - - - - - - -
// UserManual — embedded panel for the in-app user manual. Composes the
// left-nav (ManualNav) + content viewer (ManualContent) and owns the
// selected-slug state.
//
// Lives inside HelpModal as one of two tabs (the other being training
// videos). Not a modal of its own — the chosen architecture (per the
// approved plan) keeps both video and manual entry points in a single
// "?" popup so the help surface stays unified.
//
// Props:
//   language       — content language (defaults to DEFAULT_LANGUAGE).
//   initialSlug    — optional page to land on. Falls back to the first
//                    available page if missing or filtered out.
//   hiddenGroups   — array of group slug prefixes (e.g. ["time-travel"])
//                    whose pages should NOT appear in the nav. Used by
//                    HelpModal to mirror access gates (e.g. Time Travel
//                    chapter is hidden for users without timeTravelAccess).

function UserManual({
  language = DEFAULT_LANGUAGE,
  initialSlug,
  hiddenGroups,
}) {
  const allPages = getManualPages(language);
  const pages = filterManualPages(allPages, hiddenGroups);
  const findVisiblePage = (slug) => pages.find((p) => p.slug === slug);
  const startingSlug =
    initialSlug && findVisiblePage(initialSlug)
      ? initialSlug
      : pages[0]?.slug;
  const [selectedSlug, setSelectedSlug] = useState(startingSlug);
  const selectedPage = findVisiblePage(selectedSlug) ?? pages[0];

  return (
    <div className="flex gap-4 min-h-[24rem]">
      <ManualNav
        pages={pages}
        selectedSlug={selectedSlug}
        onSelect={setSelectedSlug}
      />
      <div className="flex-1 min-w-0">
        <ManualContent
          page={selectedPage}
          pages={pages}
          onNavigate={setSelectedSlug}
          hiddenGroups={hiddenGroups}
        />
      </div>
    </div>
  );
}

export default UserManual;
